import {announce} from '@github-ui/aria-live'
import type {CopilotChatAction} from '@github-ui/copilot-chat-state/copilot-chat-reducer-types'
import type {CopilotChatReference} from '@github-ui/copilot-chat-types'

// Reference types that carry a `number` and are announced to screen readers when
// added or removed.
function numberedReference(reference: CopilotChatReference | undefined) {
  if (
    reference &&
    (reference.type === 'issue' || reference.type === 'pull-request' || reference.type === 'discussion')
  ) {
    return reference
  }
  return undefined
}

/**
 * Emits screen-reader announcements for reference changes.
 *
 * These are DOM side effects and must run at the dispatch boundary, not inside the
 * reducer — `copilotChatReducer` must stay a pure `(state, action) => state` function
 * so it is safe to run during SSR and to replay (e.g. React StrictMode double-invoke).
 */
export function announceReferenceChange(action: CopilotChatAction): void {
  switch (action.type) {
    case 'ADD_REFERENCE': {
      const reference = numberedReference(action.reference)
      if (reference) {
        announce(`Adding ${reference.type} ${reference.number} as a reference.`)
      }
      break
    }
    case 'REMOVE_REFERENCES': {
      const reference = numberedReference(action.references[0])
      if (reference) {
        announce(`Removing ${reference.type} ${reference.number} as a reference.`)
      }
      break
    }
  }
}
